import { EditGroupsTableQuery } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';

/**
 * Calculate the customer price, from the host price
 */
export default function calculateCustomerPriceZD(
  hostPriceZD: number,
  startDate: string,
  commissions: EditGroupsTableQuery['trip']['commissionOverrides'],
) {
  const commissionOverride = commissions.items.find((commission) => {
    const validFrom = DateTime.fromISO(commission.validFrom);
    const validTo = DateTime.fromISO(commission.validTo);
    const start = DateTime.fromISO(startDate);

    return start >= validFrom && start < validTo;
  });

  if (commissionOverride) {
    const commission = parseFloat(commissionOverride.percentage);
    return Math.round(hostPriceZD / (1 - commission));
  }

  // Otherwise use the default commission
  const defaultCommission = parseFloat(commissions.defaultCommission);
  return Math.round(hostPriceZD / (1 - defaultCommission));
}
